<template>
    <div class="search-bar-filters">
        <p class="typographies-paragraph-small-bold">
            {{ $l10n.__('Vous cherchez quelque chose en particulier ?') }}
        </p>
        <ul class="search-bar-filters__list">
            <li
                v-for="item in activeFilters"
                :key="item.value"
                :data-bot="'search-bar-filters__btn--' + item.dataBot"
            >
                <CompassTagInteractive
                    :modelValue="item.value"
                    variant="selectable"
                    :isSelected="isSelected(item)"
                    :icon="item.icon"
                    :valueLabel="item.name"
                    @change="handleValueChange"
                />
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props: {
        currentFilter: {
            type: Array,
            default: () => [],
        },
        permissions: {
            type: Object,
            default: () => ({}),
        },
        filtersList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            filters: [
                {
                    name: this.$l10n.__('Société'),
                    value: 'company',
                    icon: 'nav-company',
                    isAvailable: this.permissions.company,
                    dataBot: 'company',
                },
                {
                    name: this.$l10n.__('Contact'),
                    value: 'contact',
                    icon: 'nav-contact',
                    isAvailable: this.permissions.contact,
                    dataBot: 'contact',
                },
                {
                    name: this.$l10n.__('Opportunité'),
                    value: 'opportunity',
                    icon: 'nav-opportunity',
                    isAvailable: this.permissions.opportunity,
                    dataBot: 'opportunity',
                },
                {
                    name: this.$l10n.__('Document'),
                    value: 'document,purchase,redactor',
                    icon: 'nav-billing',
                    isAvailable: this.permissions.document,
                    dataBot: 'document',
                },
                {
                    name: this.$l10n.__('Produit / Service'),
                    value: 'item.product,item.service,declination',
                    icon: 'nav-catalogue',
                    isAvailable: this.permissions.item,
                    dataBot: 'product',
                },
                {
                    name: this.$l10n.__('Support'),
                    value: 'ticket',
                    icon: 'nav-support',
                    isAvailable: this.permissions.ticket,
                    dataBot: 'ticket',
                },
                {
                    name: this.$l10n.__('Particulier'),
                    value: 'individual',
                    icon: 'nav-contact',
                    isAvailable: this.permissions.individual,
                    dataBot: 'individual',
                },
            ],
            selectedFilter: this.currentFilter.join(','),
        };
    },
    computed: {
        activeFilters() {
            const filters =
                this.filtersList.length > 0
                    ? this.filters.filter((item) => this.filtersList.includes(item.dataBot))
                    : this.filters;
            return filters.filter((item) => item.isAvailable);
        },
        isSelected() {
            return (item) => {
                if (this.currentFilter.length === 0) {
                    return item.value === this.selectedFilter;
                }

                return this.currentFilter.toString() === item.value;
            };
        },
    },
    watch: {
        selectedFilter(newValue) {
            if (newValue !== '') {
                const filtersArray = this.selectedFilter.split(',');
                this.$emit('change', filtersArray);
            } else {
                this.$emit('change', []);
            }
        },
        currentFilter(newValue) {
            if (newValue.length === 0) {
                this.selectedFilter = '';
            } else {
                this.selectedFilter = newValue.toString();
            }
        },
    },
    methods: {
        handleValueChange(newItem) {
            if (newItem.value !== this.selectedFilter) {
                this.selectedFilter = newItem.value;
            } else {
                this.selectedFilter = '';
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.search-bar-filters {
    color: var(--colors-common-text-subtle-default, #565665);

    p {
        margin: 0 0 var(--spacing-0);
    }

    &__list {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        gap: var(--spacing-1);
        margin: 0;
        padding: 0;

        li {
            flex-shrink: 0;
        }
    }
}
</style>
